import { jsx as _jsx } from "react/jsx-runtime";
import { KOALA, GREAT_WHITE } from 'HubStyleTokens/colors';
import styled, { keyframes } from 'styled-components';
const SKELETON_TITLE_WIDTH = 170;
const SKELETON_TITLE_HEIGHT = 16;
const SKELETON_TITLE_MARGIN_TOP = 12;
const SKELETON_DESCRIPTION_WIDTH = 520;
const SKELETON_DESCRIPTION_HEIGHT = 40;
const SKELETON_DESCRIPTION_MARGIN_TOP = 9;
const SKELETON_DESCRIPTION_MARGIN_BOTTOM = 16;
const pulse = keyframes(["0%{background-color:", "}50%{background-color:", "}100%{background-color:", "}"], KOALA, GREAT_WHITE, KOALA);
const SkeletonBase = styled.div.withConfig({
  displayName: "Skeleton__SkeletonBase",
  componentId: "sc-1w9rm8j-0"
})(["display:inline-block;height:", "px;width:", "px;border-radius:3px;margin-top:", "px;margin-bottom:", "px;animation:", " 2s ease-in-out infinite;"], props => props.type === 'description' ? SKELETON_DESCRIPTION_HEIGHT : SKELETON_TITLE_HEIGHT, props => props.type === 'description' ? SKELETON_DESCRIPTION_WIDTH : SKELETON_TITLE_WIDTH, props => props.type === 'description' ? SKELETON_DESCRIPTION_MARGIN_TOP : SKELETON_TITLE_MARGIN_TOP, props => props.type === 'description' ? SKELETON_DESCRIPTION_MARGIN_BOTTOM : 0, pulse);

const Skeleton = props => /*#__PURE__*/_jsx(SkeletonBase, Object.assign({}, props));

export default Skeleton;